/* PDP behaviors: gallery, qty, stock variant resolution, VIN checker,
   transfer-case conflict, garage fit-check, AJAX ATC, sticky bar (Recipe 11
   proxy), GA4 events. IDs stay strings throughout (HP2). */
(function () {
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;
  var form = pdp.querySelector('[data-pdp-form], form[action*="/cart/add"]');
  var atc = pdp.querySelector('[data-pdp-atc]');
  var atcLabel = pdp.querySelector('[data-atc-label]');
  var atcMsg = pdp.querySelector('[data-atc-msg]');
  var isBundle = pdp.hasAttribute('data-pdp-bundle');
  var vinTools = {};

  /* Sliding thumb for segmented option sliders (shared with tdt-bundle.js,
     which renders the same markup). Radio state stays the no-JS fallback. */
  window.tdtInitSliders = function (scope) {
    (scope || document).querySelectorAll('[data-option-slider]').forEach(function (fs) {
      var track = fs.querySelector('.option-slider__track');
      if (!track || track.dataset.thumbBound) return;
      track.dataset.thumbBound = '1';
      var thumb = track.querySelector('[data-slider-thumb]');
      if (!thumb) {
        thumb = document.createElement('span');
        thumb.className = 'option-slider__thumb';
        thumb.setAttribute('data-slider-thumb', '');
        thumb.setAttribute('aria-hidden', 'true');
        track.insertBefore(thumb, track.firstChild);
      }
      function place(animate) {
        var checked = track.querySelector('input:checked');
        var label = checked && track.querySelector('label[for="' + checked.id + '"]');
        if (!label) { thumb.style.opacity = '0'; return; }
        if (!animate) thumb.style.transition = 'none';
        thumb.style.width = label.offsetWidth + 'px';
        thumb.style.height = label.offsetHeight + 'px';
        thumb.style.transform = 'translate(' + label.offsetLeft + 'px,' + label.offsetTop + 'px)';
        thumb.style.opacity = '';
        if (!animate) requestAnimationFrame(function () { thumb.style.transition = ''; });
      }
      fs.classList.add('option-slider--js');
      track.addEventListener('change', function () { place(true); });
      window.addEventListener('resize', function () { place(false); });
      place(false);
    });
  };
  window.tdtInitSliders(pdp);

  /* Gallery — the main image ships with a responsive srcset, which wins over a
     bare src swap, so both attributes are replaced together */
  var mainImg = pdp.querySelector('.pdp__image');
  function setMainImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
  }
  window.tdtSetMainImage = setMainImage; /* kit option picker in tdt-bundle.js */
  pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('pdp__thumb--active'); });
      thumb.classList.add('pdp__thumb--active');
      setMainImage(thumb.dataset.mediaSrc);
    });
  });

  /* Quantity */
  var qtyInput = pdp.querySelector('.pdp__qty-input');
  var minus = pdp.querySelector('[data-qty-minus]');
  var plus = pdp.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
  if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

  /* Stock variant resolution from option sliders */
  var variantsEl = pdp.querySelector('[data-pdp-variants]');
  var variantIdInput = pdp.querySelector('[data-pdp-variant-id]');
  var priceEl = pdp.querySelector('[data-pdp-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  if (variantsEl && !isBundle) {
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    var optionArea = pdp.querySelector('[data-pdp-options]');
    function resolveVariant() {
      var chosen = [];
      optionArea.querySelectorAll('[data-option-slider]').forEach(function (slider) {
        var checked = slider.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];
      if (!match) return;
      variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (stickyPrice) stickyPrice.textContent = match.price;
      if (match.image) setMainImage(match.image);
      if (atc) {
        atc.disabled = !match.available;
        if (atcLabel) atcLabel.textContent = match.available ? window.tdtStrings.addToCart : window.tdtStrings.soldOut;
      }
    }
    if (optionArea) optionArea.addEventListener('change', resolveVariant);
  }

  /* VIN checker: 17 chars + ISO 3779 check digit + engine char vs garage generation */
  var vinField = pdp.querySelector('[data-vin-field]');
  if (vinField) {
    var vinInput = vinField.querySelector('input');
    var vinMsg = vinField.querySelector('[data-vin-msg]');
    var translit = { A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,J:1,K:2,L:3,M:4,N:5,P:7,R:9,S:2,T:3,U:4,V:5,W:6,X:7,Y:8,Z:9 };
    var weights = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
    function vinCheckDigit(vin) {
      var sum = 0;
      for (var i = 0; i < 17; i++) {
        var ch = vin[i];
        var val = /[0-9]/.test(ch) ? parseInt(ch, 10) : translit[ch];
        if (val === undefined) return null;
        sum += val * weights[i];
      }
      var rem = sum % 11;
      return rem === 10 ? 'X' : String(rem);
    }
    function garageGen() {
      var g = window.tdtGarage && window.tdtGarage.get();
      if (!g) return null;
      var data = document.querySelector('[data-fitment-data]');
      var lines = [];
      try { lines = JSON.parse(data ? data.textContent : '[]'); } catch (e) {}
      var found = null;
      lines.forEach(function (line) {
        (line.gens || []).forEach(function (gen) { if (gen.handle === g.h) found = gen; });
      });
      return found;
    }
    function setVinState(state, msg) {
      vinField.classList.remove('info-field--valid', 'info-field--invalid', 'info-field--warn');
      if (state) vinField.classList.add('info-field--' + state);
      if (vinMsg && msg) vinMsg.textContent = msg;
    }
    vinInput.addEventListener('input', function () {
      vinState = null; /* an edited VIN must be checked again before it goes on the Vehicle line */
      var vin = vinInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      vinInput.value = vin;
      if (!vin.length) { setVinState(null, window.tdtStrings.vinHint); return; }
      if (vin.length !== 17) { setVinState('invalid', window.tdtStrings.vinLength.replace('%d', String(vin.length))); return; }
      if (/[IOQ]/.test(vin)) { setVinState('invalid', window.tdtStrings.vinChars); return; }
      var check = vinCheckDigit(vin);
      if (check !== null && check !== vin[8]) { setVinState('invalid', window.tdtStrings.vinDigit); return; }
      var gen = garageGen();
      if (gen && gen.vins && gen.vins.length) {
        var pos = parseInt(gen.vp, 10) || 8;
        var engineChar = vin[pos - 1];
        if (gen.vins.indexOf(engineChar) === -1) {
          setVinState('warn', window.tdtStrings.vinMismatch.replace('%c', engineChar).replace('%g', gen.label));
          return;
        }
        setVinState('valid', window.tdtStrings.vinMatch.replace('%g', gen.label));
        return;
      }
      setVinState('valid', window.tdtStrings.vinValid);
    });
    /* shared with the ATC validation below */
    vinTools.input = vinInput;
    vinTools.checkDigit = vinCheckDigit;
  }

  /* Transfer case vs Drive Type conflict (warning, never a block) */
  var tcField = pdp.querySelector('[data-transfer-case]');
  if (tcField) {
    var tcSelect = tcField.querySelector('select');
    var tcWarn = tcField.querySelector('[data-tc-warning]');
    function checkTc() {
      var drive = pdp.querySelector('input[name="properties[Drive Type]"]:checked');
      var conflict = tcSelect.value === 'No Transfer Case' && drive && /4/.test(drive.value);
      if (tcWarn) tcWarn.classList.toggle('is-hidden', !conflict);
      tcField.classList.toggle('info-field--warn', conflict);
    }
    tcSelect.addEventListener('change', checkTc);
    pdp.addEventListener('change', function (e) { if (e.target.name === 'properties[Drive Type]') checkTc(); });
  }

  /* Full product fitment {line_handle: [years]} from cart_catalyst.fitment_years.
     Empty object = no fitment recorded = fits every truck. */
  function fitmentYears() {
    var el = document.querySelector('[data-fitment-years]');
    var map = null;
    try { map = JSON.parse(el ? el.textContent : 'null'); } catch (e) {}
    return map && typeof map === 'object' && !Array.isArray(map) ? map : {};
  }

  /* Vehicle fitment (cart_catalyst.fitment_vehicles): {"make|model|body": [years]}.
     null = no value = fits every truck (never "doesn't fit"). */
  function jsonData(sel) {
    var el = document.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function garageVehicle() {
    var g = window.tdtGarage && window.tdtGarage.get();
    return g && g.mk && g.md && g.bd && g.vy ? g : null;
  }
  function fitsVehicle(fv, v) {
    if (!fv || typeof fv !== 'object') return true;
    var years = fv[v.mk + '|' + v.md + '|' + v.bd];
    var y = Math.floor(parseFloat(v.vy));
    return !!years && years.some(function (yr) { return Math.floor(parseFloat(yr)) === y; });
  }
  var productFv = jsonData('[data-fitment-vehicles]');

  /* VIN engine character -> { code } for a generation, or null. A generation's
     vin_engine_map ({ "Y": {code}, "K": {code, wmi: ["1HT"]} }) wins: a char with
     wmi only matches VINs starting with one of those prefixes. Without a map the
     char must be in vin_engine_chars (code then comes from engine_codes). */
  function engineMatch(gen, vin) {
    var pos = parseInt(gen.vp, 10) || 8;
    var ch = vin[pos - 1];
    var map = gen.vem;
    if (typeof map === 'string') { try { map = JSON.parse(map); } catch (e) { map = null; } }
    if (map && typeof map === 'object' && Object.keys(map).length) {
      var e = map[ch];
      if (!e) return null;
      if (e.wmi && e.wmi.length && !e.wmi.some(function (w) { return vin.indexOf(w) === 0; })) return null;
      return { code: e.code || null };
    }
    return (gen.vins || []).indexOf(ch) > -1 ? { code: null } : null;
  }

  /* Options the truck answers (cart_catalyst.fitment_options, marked data-fitment-option). */
  function fitmentSliders(area) {
    return Array.prototype.slice.call(area.querySelectorAll('[data-option-slider]'));
  }
  function pendingFitmentOption() {
    var area = pdp.querySelector('[data-pdp-options]');
    if (!area) return null;
    var open = fitmentSliders(area).filter(function (sl) {
      return sl.hasAttribute('data-fitment-option') && !sl.classList.contains('is-hidden') && !sl.querySelector('input:checked');
    })[0];
    return open || null;
  }

  /* Variants that fit different trucks. The saved truck is the one the shopper
     last picked, not necessarily the truck this part is for, so it never blocks
     a purchase: every variant stays selectable.
     - Truck fits a variant: options the truck answers (fitment_options) are set
       from it and shown as "Cab Chassis · for your 2020 Ram 3500 · Change";
       Change opens the normal selector.
     - Truck fits no variant, or no truck: those options show as normal, on the
       product's default value like any other option.
     Values no fitting variant offers get a short "Not for your <truck>" note.
     A variant with no fitment of its own fits whatever the product fits. */
  (function () {
    var area = pdp.querySelector('[data-pdp-options]');
    var list = jsonData('[data-pdp-variants]') || jsonData('[data-bundle-parent-variants]');
    if (!area || !Array.isArray(list) || !list.length) return;
    var sliders = fitmentSliders(area);
    var fitIdx = [];
    sliders.forEach(function (sl, i) { if (sl.hasAttribute('data-fitment-option')) fitIdx.push(i); });
    var atcBtn = pdp.querySelector('[data-pdp-atc]');
    var atcText = atcBtn && atcBtn.querySelector('[data-atc-label]');
    function holdAtc() {
      var open = pendingFitmentOption();
      if (!open || !atcBtn) return;
      atcBtn.disabled = true;
      var legend = open.querySelector('legend');
      if (atcText) atcText.textContent = window.tdtStrings.chooseOption.replace('%o%', legend ? legend.firstChild.textContent.trim() : '');
    }
    function waitForChoice() {
      if (!fitIdx.length) return;
      holdAtc();
      /* the variant scripts re-enable add to cart once every option is chosen */
      area.addEventListener('change', function () { setTimeout(holdAtc, 0); });
    }
    var v = garageVehicle();
    var fitting = v ? list.filter(function (x) { return fitsVehicle(x.fv != null ? x.fv : productFv, v); }) : [];
    if (!v || !fitting.length) { waitForChoice(); return; }

    var truck = v.vy + ' ' + (window.tdtVehicleName ? window.tdtVehicleName(v.mk, v.md) : v.mk + ' ' + v.md);
    /* A short note on values no fitting variant offers — still selectable */
    if (fitting.length < list.length) {
      var note = window.tdtStrings.notForYour.replace('%v%', truck);
      sliders.forEach(function (slider, i) {
        slider.querySelectorAll('input[type="radio"]').forEach(function (input) {
          if (fitting.some(function (x) { return x.options[i] === input.value; })) return;
          var seg = slider.querySelector('label[for="' + input.id + '"]');
          if (seg && !seg.querySelector('.option-slider__reason')) {
            var r = document.createElement('span');
            r.className = 'option-slider__reason';
            r.textContent = note;
            seg.appendChild(r);
          }
        });
      });
    }
    if (!fitIdx.length) return;
    /* Set the truck-answered options from a fitting variant, keeping the shopper's
       other choices when one fits them; otherwise take the first fitting variant whole. */
    var chosen = sliders.map(function (sl) { var c = sl.querySelector('input:checked'); return c ? c.value : null; });
    var keep = fitting.filter(function (x) {
      return x.options.every(function (o, i) { return fitIdx.indexOf(i) > -1 || o === chosen[i]; });
    })[0];
    var target = keep || fitting[0];
    var changed = false;
    sliders.forEach(function (sl, i) {
      if (keep && fitIdx.indexOf(i) === -1) return;
      sl.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (input.value === target.options[i] && !input.checked) { input.checked = true; changed = true; }
      });
    });
    /* Collapse each truck-answered option to "<value> · for your <truck> · Change" */
    fitIdx.forEach(function (i) {
      var sl = sliders[i];
      var legend = sl.querySelector('legend');
      var row = document.createElement('p');
      row.className = 'option-slider__chosen';
      var name = document.createElement('span');
      name.className = 'option-slider__chosen-label';
      name.textContent = legend ? legend.firstChild.textContent.trim() : '';
      var val = document.createElement('span');
      val.className = 'option-slider__chosen-value';
      val.textContent = target.options[i] + ' · ' + window.tdtStrings.forYour.replace('%v%', truck);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'option-slider__change';
      btn.textContent = window.tdtStrings.changeOption;
      btn.addEventListener('click', function () {
        row.remove();
        sl.classList.remove('is-hidden');
        window.dispatchEvent(new Event('resize')); /* re-place the slider thumb now it's visible */
        var cur = sl.querySelector('input:checked');
        if (cur) cur.focus();
      });
      row.appendChild(name); row.appendChild(val); row.appendChild(btn);
      sl.parentNode.insertBefore(row, sl);
      sl.classList.add('is-hidden');
    });
    if (changed) {
      area.setAttribute('data-vehicle-adjusted', '');
      var last = sliders[sliders.length - 1] && sliders[sliders.length - 1].querySelector('input:checked');
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    }
  })();

  /* PDP year pills: with a saved truck whose line this product fits, show that
     line's pill only, plus a "Fits N more trucks" pill that expands the rest.
     Pills render server-side; the garage lives in the browser, so this is JS. */
  (function () {
    var wrap = pdp.querySelector('.year-pills--pdp');
    var g0 = window.tdtGarage && window.tdtGarage.get();
    if (!wrap || !g0) return;
    var line0 = g0.ln;
    if (!line0) {
      try {
        JSON.parse((document.querySelector('[data-fitment-data]') || {}).textContent || '[]').forEach(function (l) {
          (l.gens || []).forEach(function (gg) { if (gg.handle === g0.h) line0 = l.handle; });
        });
      } catch (e) {}
    }
    var pills = Array.prototype.slice.call(wrap.querySelectorAll('.year-pill[data-line]'));
    var mine = pills.filter(function (p) { return p.getAttribute('data-line') === line0; });
    var others = pills.filter(function (p) { return mine.indexOf(p) === -1; });
    if (!mine.length || !others.length) return;
    others.forEach(function (p) { p.classList.add('is-collapsed'); });
    var more = window.tdtStrings.moreTrucks.replace('%n%', String(others.length));
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'year-pill year-pill--toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = more;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      others.forEach(function (p) { p.classList.toggle('is-collapsed', !open); });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? window.tdtStrings.fewerTrucks : more;
      wrap.appendChild(btn);
    });
    wrap.appendChild(btn);
  })();

  /* Garage fit-check: the garage's line must be in the product's fitment, with
     the garage year (when it carries one) or any year of its generation */
  var fit = pdp.querySelector('[data-pdp-fit]');
  if (fit) {
    var g = window.tdtGarage && window.tdtGarage.get();
    var fy = fitmentYears();
    if (g && Object.keys(fy).length) {
      var data2 = document.querySelector('[data-fitment-data]');
      var lines2 = [];
      try { lines2 = JSON.parse(data2 ? data2.textContent : '[]'); } catch (e) {}
      var gen2 = null, lineHandle = null;
      lines2.forEach(function (line) {
        (line.gens || []).forEach(function (gg) { if (gg.handle === g.h) { gen2 = gg; lineHandle = line.handle; } });
      });
      if (gen2) {
        var garageLine = g.ln || lineHandle;
        var veh = garageVehicle();
        var fits = veh ? fitsVehicle(productFv, veh) : (fy[garageLine] || []).some(function (yr) {
          yr = parseFloat(yr);
          /* Year-specific when the garage carries one (033); generation range otherwise */
          if (g.y != null) return yr === g.y || Math.floor(yr) === Math.floor(g.y);
          return yr >= gen2.ys && yr <= gen2.ye;
        });
        fit.classList.remove('is-hidden');
        var badge = fit.querySelector(fits ? '[data-fit-yes]' : '[data-fit-check]');
        if (badge) {
          badge.classList.remove('is-hidden');
          var lbl = badge.querySelector('[data-fit-label]');
          if (lbl) lbl.textContent = (g.yl ? g.l + ' · ' + g.yl : g.l) + (g.en ? ' · ' + g.en : '');
        }
      }
    }
  }

  /* Custom ATC validation (no native tooltips): red border + message beside the
     field title; a valid VIN outside this product's truck range soft-blocks via
     the mismatch modal (design: PDP VIN Mismatch Modal). HP2: ids stay strings. */
  if (form && atc) {
    form.setAttribute('novalidate', '');
    var vinModal = document.querySelector('[data-vin-modal]');
    var modalInput = vinModal && vinModal.querySelector('[data-vin-modal-input]');
    var modalBodyEl = vinModal && vinModal.querySelector('[data-vin-modal-body]');
    var vehicleProp = form.querySelector('[data-vehicle-prop]');
    var modalMode = null;          /* 'format' | 'mismatch' — what the open modal is warning about */
    var vinState = null;           /* { key, detail } from the last check of the current VIN */
    function setVinStatus(key, detail) { vinState = { key: key, detail: detail || null }; }
    function engineText(gen, line, code) {
      var ec = code ? [code] : gen.ec;
      if (typeof ec === 'string') { try { ec = JSON.parse(ec); } catch (e) { ec = ec ? [ec] : []; } }
      var parts = [];
      var codes = (Array.isArray(ec) ? ec : []).filter(Boolean).join('/');
      if (codes) parts.push(codes);
      if (gen.disp) parts.push(gen.disp);
      if (line && line.fam) parts.push(line.fam);
      return parts.join(' ');
    }
    /* One visible "Vehicle" property: "2008 Ford F-350 · Cab & Chassis · 6.4L Power
       Stroke · VIN … checked". Year/make/model/body from the menu choice; engine from
       the VIN decode, else the saved generation; VIN part only when one was entered. */
    function composeVehicle() {
      if (!vehicleProp) return;
      var g = window.tdtGarage && window.tdtGarage.get();
      var veh = garageVehicle();
      var vin = vinTools.input && vinTools.input.value ? vinTools.input.value.toUpperCase() : '';
      var dec = vinState && vinState.key === 'vinStatusPassed' ? vinState.detail : null;
      var parts = [];
      var nameOf = window.tdtVehicleName || function (mk, md) { return mk + ' ' + md; };
      if (veh) {
        parts.push(veh.vy + ' ' + nameOf(veh.mk, veh.md));
        if (veh.bdl) parts.push(veh.bdl);
      } else if (dec) {
        parts.push(String(dec.y));
      }
      var engine = dec ? dec.engine : '';
      if (!engine && g && g.h) {
        linesData().forEach(function (line) {
          (line.gens || []).forEach(function (gen) { if (!engine && gen.handle === g.h && veh) engine = engineText(gen, line, veh.en || null); });
        });
      }
      if (engine) parts.push(engine);
      if (vin) {
        var k = vinState ? vinState.key : 'vinStatusPassed';
        var tpl = k === 'vinStatusMismatch' ? window.tdtStrings.vehicleVinMismatch
          : k === 'vinStatusFormat' ? window.tdtStrings.vehicleVinFormat : window.tdtStrings.vehicleVinChecked;
        parts.push(tpl.replace('%v%', vin));
      }
      vehicleProp.value = parts.join(' \u00b7 ');
      vehicleProp.disabled = !parts.length;
    }
    /* Decodes a passing VIN to { y, engine } for the Vehicle line.
       A generation matches when (a) its line is in the product's fitment (any
       line when the product has none), (b) the model year is in its range, start
       floored (a VIN can't tell 2007 from 2007.5), and (c) the VIN character at
       its engine position is one of its engine chars. Two generations can share
       a model year (LBZ 2007 / LMM 2007.5): the engine char settles it.
       No match -> '' and the status stays plain "Passed". */
    function vinDetail(vin) {
      if (!vin || vin.length !== 17) return null;
      var fits = fitmentYears();
      var anyLine = !Object.keys(fits).length;
      var years = vinYears(vin[9]);
      var hit = null;
      years.forEach(function (y) {
        if (hit) return;
        linesData().forEach(function (line) {
          if (hit || !(anyLine || fits[line.handle])) return;
          (line.gens || []).forEach(function (gen) {
            if (hit) return;
            var em = engineMatch(gen, vin);
            if (!em) return;
            if (y >= Math.floor(parseFloat(gen.ys)) && y <= parseFloat(gen.ye)) hit = { y: y, gen: gen, line: line, code: em.code };
          });
        });
      });
      if (!hit) return null;
      return { y: hit.y, engine: engineText(hit.gen, hit.line, hit.code) };
    }

    function headError(fieldEl, msg) {
      if (!fieldEl) return;
      fieldEl.classList.add('info-field--invalid');
      var head = fieldEl.querySelector('.info-field__head');
      if (!head) return;
      var err = head.querySelector('[data-field-error]');
      if (!err) {
        err = document.createElement('span');
        err.className = 'info-field__head-error';
        err.setAttribute('data-field-error', '');
        head.appendChild(err);
      }
      err.textContent = msg;
      err.hidden = false;
    }
    function clearErrors() {
      pdp.querySelectorAll('.info-field--invalid').forEach(function (f) { f.classList.remove('info-field--invalid'); });
      pdp.querySelectorAll('[data-field-error]').forEach(function (e2) { e2.hidden = true; });
    }
    pdp.addEventListener('input', function (e) {
      var f = e.target.closest && e.target.closest('[data-info-field]');
      if (f && f.classList.contains('info-field--invalid') && String(e.target.value || '').trim()) {
        f.classList.remove('info-field--invalid');
        var err = f.querySelector('[data-field-error]');
        if (err) err.hidden = true;
      }
    });

    function vinFormatError(vin) {
      if (vin.length !== 17) return window.tdtStrings.vinLength.replace('%d', String(vin.length));
      if (/[IOQ]/.test(vin)) return window.tdtStrings.vinChars;
      var c = vinTools.checkDigit ? vinTools.checkDigit(vin) : null;
      if (c !== null && c !== vin[8]) return window.tdtStrings.vinDigit;
      return null;
    }
    function validate() {
      clearErrors();
      var firstBad = null;
      pdp.querySelectorAll('[data-info-field]').forEach(function (fieldEl) {
        var input = fieldEl.querySelector('input[required], textarea[required], select[required]');
        if (!input) return;
        if (!String(input.value || '').trim()) {
          headError(fieldEl, window.tdtStrings.fillField);
          if (!firstBad) firstBad = input;
        }
      });
      /* A VIN that fails the format check no longer hard-blocks here — the
         submit handler routes it to the modal, which offers "add anyway".
         Without a modal on the page it still blocks, as before. */
      if (!firstBad && !vinModal && vinTools.input && vinTools.input.value) {
        var fmt = vinFormatError(vinTools.input.value.toUpperCase());
        if (fmt) { headError(vinTools.input.closest('[data-info-field]'), fmt); firstBad = vinTools.input; }
      }
      if (firstBad) {
        firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        firstBad.focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    /* Product truck-range check against cart_catalyst.fitment_years */
    function fitData() { return fitmentYears(); }
    function linesData() {
      try { return JSON.parse((document.querySelector('[data-fitment-data]') || {}).textContent || '[]'); } catch (e) { return []; }
    }
    var yearCodes = 'ABCDEFGHJKLMNPRSTVWXY123456789';
    function vinYears(ch) {
      var i = yearCodes.indexOf(ch);
      if (i < 0) return [];
      return [1980 + i, 2010 + i].filter(function (y) { return y >= 1990 && y <= 2032; }).sort(function (a, b) { return b - a; });
    }
    function vinProductCheck(vin) {
      var fits = fitData();
      if (!Object.keys(fits).length) return { ok: true }; /* no fitment recorded = fits every truck — no gate */
      var years = vinYears(vin[9]);
      var decoded = null, ok = false;
      linesData().forEach(function (line) {
        (line.gens || []).forEach(function (gen) {
          if (!engineMatch(gen, vin)) return;
          years.forEach(function (y) {
            /* A VIN can't record a half model year (a 2007.5 truck's VIN says 2007),
               so compare with the whole start year; the engine character already
               separates it from the generation before. */
            if (y >= Math.floor(parseFloat(gen.ys)) && y <= parseFloat(gen.ye)) {
              if (!decoded) decoded = { year: y, title: line.title };
              /* whole years: a VIN can't tell 2007 from 2007.5 */
              if ((fits[line.handle] || []).some(function (fy2) { return Math.floor(parseFloat(fy2)) === y; })) ok = true;
            }
          });
        });
      });
      return { ok: ok, decoded: decoded, years: years, fits: fits };
    }
    function mismatchBody(res) {
      var reads = res.decoded ? res.decoded.year + ' ' + res.decoded.title
        : window.tdtStrings.vinReadsFallback.replace('%y%', String(res.years[0] || '—'));
      /* Every line the product fits, each with its own range, in truck-menu order */
      var known = linesData().slice().sort(function (a, b) { return (a.nav || 999) - (b.nav || 999); });
      var order = known.map(function (l) { return l.handle; });
      Object.keys(res.fits).forEach(function (h) { if (order.indexOf(h) === -1) order.push(h); });
      var parts = [];
      order.forEach(function (h) {
        var ys = (res.fits[h] || []).map(parseFloat).filter(isFinite);
        if (!ys.length) return;
        var title = h;
        known.forEach(function (l) { if (l.handle === h) title = l.title; });
        var a = Math.min.apply(null, ys), b = Math.max.apply(null, ys);
        parts.push(window.tdtStrings.kitFits
          .replace('%a%', String(a)).replace('%b%', String(b)).replace('%l%', title)
          .replace(String(a) + '–' + String(a), String(a)));
      });
      return window.tdtStrings.vinModalBody.replace('%v%', reads).replace('%r%', parts.join(', '));
    }
    function formatBody(fmt) { return window.tdtStrings.vinModalFormatBody.replace('%reason%', fmt); }
    function openModal(body, isError) {
      modalInput.value = vinTools.input.value;
      modalBodyEl.textContent = body;
      modalBodyEl.classList.toggle('is-error', !!isError);
      modalMode = isError ? 'format' : 'mismatch';
      vinModal.classList.remove('is-hidden');
      setTimeout(function () { modalInput.focus(); }, 60);
    }
    function closeModal() { vinModal.classList.add('is-hidden'); }
    if (vinModal) {
      vinModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-vin-modal-close]') || e.target.classList.contains('pdp-vin-modal__scrim')) { closeModal(); return; }
        if (e.target.closest('[data-vin-modal-anyway]')) {
          vinTools.input.value = modalInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          vinTools.input.dispatchEvent(new Event('input'));
          setVinStatus(modalMode === 'format' ? 'vinStatusFormat' : 'vinStatusMismatch');
          closeModal();
          doAdd();
          return;
        }
        if (e.target.closest('[data-vin-modal-recheck]')) {
          var vin = modalInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          modalInput.value = vin;
          var fmt = vinFormatError(vin);
          if (fmt) { modalBodyEl.textContent = formatBody(fmt); modalBodyEl.classList.add('is-error'); modalMode = 'format'; return; }
          var res = vinProductCheck(vin);
          vinTools.input.value = vin;
          vinTools.input.dispatchEvent(new Event('input'));
          if (res.ok) { setVinStatus('vinStatusPassed', vinDetail(vin)); closeModal(); doAdd(); }
          else { modalBodyEl.textContent = mismatchBody(res); modalBodyEl.classList.remove('is-error'); modalMode = 'mismatch'; }
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !vinModal.classList.contains('is-hidden')) closeModal();
      });
    }

    /* The truck — Vehicle, Modifications and the truck questions — goes on the
       order once, as cart attributes (assets/tdt-trucks.js), not on this line:
       a line's properties print beside it on every packing slip and Shippo
       label, and a kit's beside every one of its parts. What is left on the
       line is about the part itself (a tuner serial, say). Without
       tdt-trucks.js on the page the fields stay on the line, as before. */
    function truckFields() {
      var data = new FormData(form);
      var fields = {};
      (window.tdtTrucks ? window.tdtTrucks.fields : []).forEach(function (name) {
        var v = data.get('properties[' + name + ']');
        if (typeof v === 'string' && v.trim()) fields[name] = v.trim();
      });
      return fields;
    }
    function lineData(truck) {
      var data = new FormData(form);
      if (!truck) return data;
      window.tdtTrucks.fields.forEach(function (name) { data.delete('properties[' + name + ']'); });
      if (truck.multi && truck.number) data.set('properties[Truck]', String(truck.number));
      return data;
    }

    function doAdd() {
      composeVehicle();
      /* Trim typed line properties (serials etc.) so stray spaces don't reach the order */
      form.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]').forEach(function (el) { el.value = el.value.trim(); });
      atc.disabled = true;
      if (atcLabel) atcLabel.textContent = window.tdtStrings.adding;
      if (atcMsg) atcMsg.classList.add('is-hidden');
      var truck = null;
      var prepared = window.tdtTrucks
        ? window.tdtTrucks.prepare(truckFields()).catch(function () { return null; })
        : Promise.resolve(null);
      prepared
        .then(function (t) {
          truck = t;
          return fetch('/cart/add.js', { method: 'POST', body: lineData(truck) });
        })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function () {
          if (truck) return window.tdtTrucks.commit(truck.record, truck.number).catch(function () {});
        })
        .then(function () {
          atc.classList.add('pdp__atc--success');
          if (atcLabel) atcLabel.textContent = window.tdtStrings.added;
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (c) {
              c.textContent = cart.item_count; c.classList.remove('is-hidden');
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { total: cart.total_price, count: cart.item_count } }));
          });
          document.dispatchEvent(new CustomEvent('tdt:added'));
          setTimeout(function () {
            atc.disabled = false;
            atc.classList.remove('pdp__atc--success');
            if (atcLabel) atcLabel.textContent = window.tdtStrings.addToCart;
          }, 2500);
        })
        .catch(function (err) {
          /* The add failed: release the truck script without writing a truck,
             and undo any "Truck: 1" prepare() put on the lines already there. */
          if (truck) window.tdtTrucks.commit(truck.record, null).then(window.tdtTrucks.reconcile);
          atc.disabled = false;
          if (atcLabel) atcLabel.textContent = window.tdtStrings.addToCart;
          if (atcMsg) {
            atcMsg.textContent = (err && err.description) || window.tdtStrings.atcError;
            atcMsg.classList.remove('is-hidden');
            atcMsg.classList.add('pdp__atc-msg--error');
          }
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) return;
      var openOpt = pendingFitmentOption();
      if (openOpt) { openOpt.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (vinModal && vinTools.input && vinTools.input.value) {
        var vin = vinTools.input.value.toUpperCase();
        var fmt = vinFormatError(vin);
        if (fmt) {
          headError(vinTools.input.closest('[data-info-field]'), fmt);
          openModal(formatBody(fmt), true);
          return;
        }
        var res = vinProductCheck(vin);
        if (!res.ok) { openModal(mismatchBody(res), false); return; }
      }
      if (vinTools.input && vinTools.input.value) setVinStatus('vinStatusPassed', vinDetail(vinTools.input.value.toUpperCase()));
      doAdd();
    });
  }

  /* Sticky bar: Recipe 11 proxy — clicks the real button, never a second submit */
  var sticky = document.querySelector('[data-pdp-sticky]');
  if (sticky && atc) {
    var stickyAtc = sticky.querySelector('[data-sticky-atc]');
    if (stickyAtc) stickyAtc.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    /* When the bar comes back, replay the earned stages in order (1 -> n)
       instead of stray segments re-pulsing on their own */
    function cascadeStages() {
      var segs = sticky.querySelectorAll('[data-tier-segs] .tier-meter__seg');
      Array.prototype.filter.call(segs, function (sEl) { return sEl.dataset.lit === '1'; })
        .forEach(function (sEl, i) {
          setTimeout(function () {
            sEl.classList.remove('tier-meter__seg--pulse');
            void sEl.offsetWidth;
            sEl.classList.add('tier-meter__seg--pulse');
            sEl.addEventListener('animationend', function cleanup() {
              sEl.classList.remove('tier-meter__seg--pulse');
              sEl.removeEventListener('animationend', cleanup);
            });
          }, 90 + i * 160);
        });
    }
    var stickyWasVisible = false;
    var observer = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      sticky.classList.toggle('pdp-sticky--visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible && !stickyWasVisible) cascadeStages();
      stickyWasVisible = visible;
    }, { rootMargin: '0px 0px -60px 0px' });
    observer.observe(atc);
    /* Mirror the main ATC into the sticky proxy — disabled state AND label,
       so edit mode ("Update bundle", set by the app block) and our own
       Adding…/Added states read the same in both places */
    function syncSticky() {
      /* The app's edit mode writes "Update bundle" — our terminology is
         "Update build" (matches the cart's EDIT BUILD), so rewrite it first */
      if (atcLabel && atcLabel.textContent.trim() === 'Update bundle' && window.tdtStrings.updateBuild) {
        atcLabel.textContent = window.tdtStrings.updateBuild;
      }
      if (!stickyAtc) return;
      stickyAtc.disabled = atc.disabled;
      var t = atc.textContent.trim();
      if (t && stickyAtc.textContent.trim() !== t) stickyAtc.textContent = t;
    }
    new MutationObserver(syncSticky)
      .observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    syncSticky();
  }

  /* Reviews slider: scroll-snap track, one viewport-width page per click
     (3 cards desktop / 2 tablet / 1 mobile fall out of the CSS flex-basis) */
  var revSlider = document.querySelector('[data-reviews-slider]');
  if (revSlider) {
    var revTrack = revSlider.querySelector('[data-reviews-track]');
    var revPrev = revSlider.querySelector('[data-reviews-prev]');
    var revNext = revSlider.querySelector('[data-reviews-next]');
    var syncRevArrows = function () {
      var max = revTrack.scrollWidth - revTrack.clientWidth;
      revSlider.classList.toggle('is-static', max <= 1);
      revPrev.disabled = revTrack.scrollLeft <= 1;
      revNext.disabled = revTrack.scrollLeft >= max - 1;
    };
    revPrev.addEventListener('click', function () {
      revTrack.scrollBy({ left: -revTrack.clientWidth, behavior: 'smooth' });
    });
    revNext.addEventListener('click', function () {
      revTrack.scrollBy({ left: revTrack.clientWidth, behavior: 'smooth' });
    });
    revTrack.addEventListener('scroll', syncRevArrows, { passive: true });
    window.addEventListener('resize', syncRevArrows);
    syncRevArrows();
  }

  /* GA4 [data-track-event] clicks are handled by the delegated listener in theme.liquid */
})();
